export const environment = {
    production: true,
    version: require('../../package.json').version,
};
